import React from "react";
import { Card, Container, Form, Input, Message } from "semantic-ui-react";
import Select from "react-select";
import lodash from "lodash/core";
import { connect } from "react-redux";
import { JsonViewer } from '@textea/json-viewer'
import * as Validation from "../../common/utils/Validation";
import {
    setKYBTestcacheCountry,
    setKYBTestcacheFormValues,
    setKYBTestcacheSourceType
} from "../actions/KYBTestCacheActions";


const countryOptions = require("../../common/resources/countries.json");

export class AddEditKYBTestCacheForm extends React.Component {

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    componentDidUpdate(prevProps, prevState, snapshot) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification)
            ? this.scrollToBottom() : null
    }

    scrollToBottom = () => {
        this.messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

    handleInputChange = (e, { name, value }) => {
        this.props.setKYBTestcacheForm({ name, value });
    };

    handleKYBTestcacheCountryChange = country => {
        this.props.setKYBTestcacheRecordCountry({ country });
    };

    handleSourceTypeChange = datasource => {
        this.props.setKYBTestcacheSourceType({ datasource });
    };

    handleKYBTestcacheDismiss = () => {
        Validation.clearMessages();
    }

    render() {
        const {
            kybTestcacheObject,
            kybPostmanObject,
            kybSourceTypeOptions,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification,
        } = this.props;

        return (
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Business Information:</h4>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '15px' }}>
                                    * Either Organization Name or Business ID is required
                                </p>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Organization Name"
                                        placeholder="Organization Name"
                                        value={kybTestcacheObject.organization_name}
                                        name="organization_name"
                                        maxLength={500}
                                    />

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Business ID"
                                        placeholder="Business ID"
                                        value={kybTestcacheObject.business_id}
                                        name="business_id"
                                        maxLength={100}
                                    />

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Business ID Type"
                                        placeholder="e.g., DUNS, VAT, etc."
                                        value={kybTestcacheObject.business_id_type}
                                        name="business_id_type"
                                        maxLength={20}
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>Data Source</label>
                                        <Select
                                            onChange={this.handleSourceTypeChange}
                                            options={kybSourceTypeOptions}
                                            placeholder="Data Source"
                                            isClearable={true}
                                            name="datasource"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(kybSourceTypeOptions, {
                                                label: kybTestcacheObject.datasource
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Address Information:</h4>

                                <Form.Field
                                    onChange={this.handleInputChange}
                                    control={Input}
                                    type="text"
                                    label="Address Line 1"
                                    placeholder="Address Line 1"
                                    value={kybTestcacheObject.addressline1}
                                    name="addressline1"
                                    maxLength={500}
                                />

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="City (Locality)"
                                        placeholder="City"
                                        value={kybTestcacheObject.locality}
                                        name="locality"
                                        maxLength={100}
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="State/Province"
                                        placeholder="State or Province"
                                        value={kybTestcacheObject.province}
                                        name="province"
                                        maxLength={100}
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Postal Code"
                                        placeholder="Postal Code"
                                        value={kybTestcacheObject.postalcode}
                                        name="postalcode"
                                        maxLength={20}
                                    />
                                    <Form.Field required>
                                        <label>Country (2-letter code)</label>
                                        <Select
                                            onChange={this.handleKYBTestcacheCountryChange}
                                            options={countryOptions}
                                            placeholder="Country"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="countrycode"
                                            value={lodash.find(countryOptions, {
                                                value: kybTestcacheObject.countrycode
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Contact Information:</h4>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Phone Number"
                                        placeholder="+1-555-123-4567"
                                        value={kybTestcacheObject.phone_number}
                                        name="phone_number"
                                        maxLength={20}
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="email"
                                        label="Email Address"
                                        placeholder="contact@company.com"
                                        value={kybTestcacheObject.full_email_address}
                                        name="full_email_address"
                                        maxLength={100}
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Domain"
                                        placeholder="company.com"
                                        value={kybTestcacheObject.domain}
                                        name="domain"
                                        maxLength={100}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Postman Request Preview:</h4>
                                <JsonViewer value={kybPostmanObject} />
                            </Card.Content>
                        </Card>

                        <div ref={this.messagesEndRef} />
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{ paddingTop: "30px" }}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleKYBTestcacheDismiss}
                                />
                            </div>
                        )
                        : null}

                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,

    kybTestcacheObject: state.support.addEditKYBTestcache.kybTestcacheObject,
    kybPostmanObject: state.support.addEditKYBTestcache.kybPostmanObject,
    kybSourceTypeOptions: state.support.kybTestcache.kybSourceTypeOptions,
});

const mapDispatchToProps = dispatch => ({
    setKYBTestcacheForm: ({ name, value }) => { dispatch(setKYBTestcacheFormValues({ name, value })) },
    setKYBTestcacheRecordCountry: ({ country }) => { dispatch(setKYBTestcacheCountry({ country })) },
    setKYBTestcacheSourceType: ({ datasource }) =>
        { dispatch(setKYBTestcacheSourceType({ datasource })) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddEditKYBTestCacheForm)

